import React from "react";
import { Globe, Users, BookOpen } from "lucide-react";

export default function StatsSection() {
  const stats = [
    { icon: Globe, label: "Countries", value: "12" },
    { icon: Users, label: "Member Experts", value: "50+" },
    { icon: BookOpen, label: "Reports & Publications", value: "100+" },
  ];

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="py-8 grid grid-cols-1 md:grid-cols-3 gap-12">
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <div
                key={i}
                className="text-center text-white flex flex-col items-center"
              >
                {/* <Icon className="w-14 h-14 mx-auto mb-3 opacity-90" /> */}
                <Icon className="w-14 h-14 block mx-auto mb-3 opacity-90" />

                <div className="text-5xl font-bold tracking-tight mb-2">
                  {stat.value}
                </div>
                <div className="text-lg opacity-90 tracking-wide">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
